import { render, staticRenderFns } from "./user-session-base-template.vue?vue&type=template&id=77823c53&scoped=true&"
import script from "./user-session-base-template.vue?vue&type=script&lang=js&"
export * from "./user-session-base-template.vue?vue&type=script&lang=js&"
import style0 from "./user-session-base-template.vue?vue&type=style&index=0&id=77823c53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77823c53",
  null
  
)

export default component.exports